const ADDITIONAL_LENGTH_VALUE = 1;

export function range(startNumber, endNumber) {
  const length = endNumber - startNumber + ADDITIONAL_LENGTH_VALUE;
  return Array.from({ length }, (_, key) => key + startNumber);
}
